<template>
  <div class="mapbox">
    <img class="cursorpointer" style="width:94px;height:32px" src="@/assets/watchBack.png" alt="" @click="back()" />
    <div  id="map" class="allnav"></div>
    
    <div class="tab">
      <slot name="tab"></slot>
    </div>
  </div>
</template>
<script>
//import mapdata from "./zhangyeMap.js";
import chinaData from '@/components/Mpa/china.json'
import echarts from "@/js/charts.js";
import maanshan from '@/components/Mpa/maanshan.json'
import gansu from '@/components/Mpa/gansu.json'
import anhui from '@/components/Mpa/anhui.json'
import hangzhou from '@/components/Mpa/hangzhou.json'
import wenzhou from '@/components/Mpa/wenzhou.json'
import zhangye from '@/components/Mpa/zhangye.json'
import zhejiangsheng from '@/components/Mpa/zhejiang.json'
// import * as THREE from "three";
import "echarts-gl";
export default {
  props: {
    tabStatus: {
      type: Boolean,
      default: true,
    },
    maptabval: {
      type: Number,
      default: 1,
    },
    province:{
      type:String
    },
    city:{
      type:String
    },
    filterType:{
      type:Number
    }
  },
  watch:{
    province(newVal){
      console.log('省更新了')
      this.beforeArea=[]
      this.beforeArea.push(newVal)
      this.initMap();
    },
    city(newVal){
      if(newVal){
        this.getWENZHOUData(newVal)
      } else{
        
      }
      
    },
    filterType(){
      this.getWENZHOUData(this.city)
    }
  },
  data() {
    return {
      tabData: ["全域", "产业园", "监控"],
      MapChart: null,
      areaData:{
        '中国':{
          data:chinaData,
          zoom:1.2,
          center:[106.62263967529299 , 34.57194829377764]
        },
        '浙江省':{
          data:zhejiangsheng,
          //data:'https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=330000_full',
          zoom:3,
          center:[119.674072265625,29.136777451729]
        },
        '甘肃省':{
          data:gansu,
          //data:'https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=620000_full',
          zoom:2.5,
          center:[102.19514944091799,38.31774663104734]
        },
        '安徽省':{

          data:anhui,
          zoom:3.5,
          center:[118.84706658203126,31.55856]
        },
        '杭州市':{
          data:hangzhou,
          zoom:7,
          center:[119.68025207519531,29.609538700135614],
          recycleList:[
            {name:'回收点1',value:[120.25193501188662,30.309785304614607],type:'recycle'},
            {name:'回收点2',value:[120.25380182936098,30.305506026422382],type:'recycle'},
            {name:'回收点3',value:[120.250744111084,30.30266233348616],type:'recycle'},
            {name:'回收点4',value:[120.28210449888613,30.314508966185247],type:'recycle'}
          ],
          disposeList:[
            {name:'处置方1',value:[120.26193501188662,30.319785304614607],type:'dispose'},
            {name:'处置方2',value:[120.24380182936098,30.325506026422382],type:'dispose'},
            {name:'处置方3',value:[120.230744111084,30.30366233348616],type:'dispose'},
            {name:'处置方4',value:[120.22210449888613,30.344508966185247],type:'dispose'}
          ]
        },
        '温州市':{
          data:wenzhou,
          zoom:20,
          center:[121.02063051879882,28.176462883282813]
        },
        '马鞍山市':{
          data:maanshan,
          zoom:7,
          center:[118.84706658203126,31.55856]
        },
        '张掖市':{
          data:zhangye,
          zoom:7,
          center:[100.467023671875,38.931806583037286]
        }
      },
      companyList:[
        {name:'杭州钱塘智慧城',value:[120.101028,30.33712],gardenNo:'5c25b630134b40e6b4be9fb58c3a026f'},
        {name:'国家大学科技园',value:[120.110435,30.267429],gardenNo:'204d784c48224fbeb9ad93813a375a57'},
        {name:'东大门交易中心',value:[120.283234,30.314215],gardenNo:'cbe05112e4be4913a6fe87009ea0adc2'}
      ],
      
        

      dataList:['中国','浙江省','甘肃省','安徽省','杭州市','温州市','马鞍山市','张掖市'],
      beforeArea:[]
    };
  },
  beforeDestroy() {
    // 清理工作 避免内存泄漏
    // 销毁监听事件
    window.removeEventListener("resize", this.resizeHandler);
    //this.disposeChart();
  },
  created() {
    this.beforeArea.push(this.province)
    
    console.log('province',this.province)
    
  },
  mounted() {
    
    if(this.city){
      console.log('有城市')
      this.beforeArea.push(this.city)
      this.initMap(this.city)
      setTimeout(() => {
        this.getWENZHOUData(this.city)
      }, 1000);
    }else{
      this.initMap();
      
    }
    
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    getWENZHOUData(city){
      this.$axios.get('/screen/screen/city/mapInfo',{params:{
        city:city,
        province:this.province
      }}).then(res=>{
        let gardenList=this.filterType==0||this.filterType==1?res.data.data.gardenMapVOS.map(item=>{
          return {name:item.name,value:[item.longitude,item.latitude],gardenNo:item.gardenNo,type:'garden'}
        }):[]
        let buildList=this.filterType==0||this.filterType==2? res.data.data.companyMapVOS.map(item=>{
          return {name:item.name,value:[item.longitude,item.latitude],type:'dispose'}
        }):[]
        let recycleList=this.filterType==0||this.filterType==3?res.data.data.collectMapVOS.map(item=>{
          return {name:item.name,value:[item.longitude,item.latitude],type:'recycle'}
        }):[]
        
        this.MapChart.setOption({
            series:[{
              name: '园区', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:gardenList,
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145j4BJaTAV.png',
              symbolSize:30
            },{
              name: '回收点', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:recycleList,
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145zvdV3F6I.png',
              symbolSize:30
            },{
              name: '处置方', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:buildList,
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145I7JNEezT.png',
              symbolSize:30
            }]
          })
      })
    }, 
    back(){
      if(this.beforeArea.length==1){
        this.$emit('mapChange',[])
        this.$router.replace('/')
        return
      }
      
      this.beforeArea.splice(this.beforeArea.length-1,1)
      this.changeArea(this.beforeArea[0])
      this.MapChart.setOption({
            series:[{
              name: '园区', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:[],
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145j4BJaTAV.png',
              symbolSize:25
            },{
              name: '回收点', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:[],
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145zvdV3F6I.png',
              symbolSize:25
            },{
              name: '处置方', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:[],
              symbol:'image://https://hlgzhhj.oss-cn-hangzhou.aliyuncs.com/2022/10/14/14/1665728259145I7JNEezT.png',
              symbolSize:25
            }]
          })
    },
    
    resizeHandler() {
      this.MapChart.resize();
    },

    // 销毁 Echarts 实例
    disposeChart() {
      this.MapChart.dispose();
    },
    getNowLocation(point){
      return [(point[0] / 180) * Math.PI,
              -Math.log(
                Math.tan((Math.PI / 2 + (point[1] / 180) * Math.PI) / 2)
              ),
            ]
    },
    //   创建地图
    async initMap(index=this.province) {
      this.MapChart = echarts.init(document.getElementById("map"));
      let data =this.areaData[index].data
      console.log(data)
      echarts.registerMap("china",data);
      this.MapChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: function loadData(result) {
            return result.name
          },
        },
        geo: {
          roam:true,
          zoom: this.areaData[index].zoom,
          show: true,
          map: "china",
          tooltip: {
            show: true,
          },
          projection: {
            project: (point) => [
              (point[0] / 180) * Math.PI,
              -Math.log(
                Math.tan((Math.PI / 2 + (point[1] / 180) * Math.PI) / 2)
              ),
            ],
            unproject: (point) => [
              (point[0] * 180) / Math.PI,
              ((2 * 180) / Math.PI) * Math.atan(Math.exp(point[1])) - 90,
            ],
          },
          center:this.getNowLocation(this.areaData[index].center),
          label: {
            show:true,
            color:'#fff'
          },
          //特殊颜色
          regions:[{
            name:'浙江省',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          },{
            name:'安徽省',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          },{
            name:'甘肃省',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          },{
            name:'张掖市',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          },{
            name:'杭州市',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          },
          {
            name:'温州市',
            type:10,
            itemStyle: {
                areaColor: '#389BB7',
                color: '#389BB7'
            }
          }],
          itemStyle: {
            normal: {
              borderColor: "#2AB8FF",
              borderWidth: 2,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(175,238,238, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(   47,79,79, 0)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              //shadowColor: "rgba(128, 217, 248, 1)",
              // shadowOffsetX: -2,
              // shadowOffsetY: 2,
              // shadowBlur: 10,
            },
            emphasis: {
              areaColor: "#389BB7",
              borderWidth: 0,
            },
          },
        },
        
      });
      this.MapChart.on('click',(params)=>{
        console.log(params)
        try{
          console.log(params.data.type)
          if(params.data.type=='recycle'){
            this.$router.push('recovery')
            return
          }
          if(params.data.type=='dispose'){
            this.$router.push({path:'dispose?name='+params.data.name,query:{lng:params.data.value[0],lat:params.data.value[1]}})
            return
          }
          if(params.data.type=='garden'){
            window.open(`http://screen.hlgu.cn/?gardenNo=${params.data.gardenNo}`)
              return true
          }
        }catch(e){
          console.log(params.data)
        }
        if(params.componentSubType=="scatter"){
          this.companyList.some(item=>{
            if(item.name==params.name){
              window.open(`http://screen.hlgu.cn/?gardenNo=${item.gardenNo}`)
              return true
            }
          })
          
        }else{
          if(params.componentType=='geo'&&this.areaData[params.name]){
            this.$emit('mapChange',[this.province,params.name])
            this.changeArea(params.name)
          }
          
          // if(params.name=='温州市'||params.name=='杭州市'){
          //   this.getWENZHOUData(params.name)
          // }
        }
        console.log(params)
        
      })
    },
    async changeArea(area){//浙江省
      if(this.dataList.includes(area)){
        if(!this.beforeArea.includes(area)) this.beforeArea.push(area)
        let data =this.areaData[area].data
        echarts.registerMap("china",data);
        this.MapChart.setOption({
            geo: {
            zoom: this.areaData[area].zoom,
            center:this.getNowLocation(this.areaData[area].center) ,
          },
        })
        if(area=='杭州市'){
          this.MapChart.setOption({
            series:[{
              name: '园区', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:this.companyList,
              symbol:'image://https://www.hlg-recycle.com/imgs/build.png',
              symbolSize:25
            },{
              name: '回收点', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:this.areaData[area].recycleList,
              symbol:'image://https://www.hlg-recycle.com/imgs/location.png',
              symbolSize:25
            },{
              name: '处置方', // series名称
              type: 'scatter', // series图表类型
              coordinateSystem: 'geo', // series坐标系类型
              data:this.areaData[area].disposeList,
              symbol:'image://https://www.hlg-recycle.com/imgs/dispose.png',
              symbolSize:25
            }]
          })
        }else{
          this.MapChart.setOption({
            series:[]
          })
        }
        this.$emit('mapChange',this.beforeArea)
      }else{
        console.log('no')
      }
    },
    convertData(data) {
      let res = [];
      for (let i = 0; i < chinaData.features.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (chinaData.features[i].properties.name == data[j].name) {
            res.push({
              name: chinaData.features[i].properties.name,
              value: chinaData.features[i].properties.center.concat(
                data[j].value
              ),
              itemStyle:{
                areaColor:'rgba(0, 0, 0, 1)'
              }
            });
          }
        }
      }
      return res;
    },

    // 定位点数据处理
    changePointData() {
      console.log(mapdata, "张掖地图数据");
      let dataArr = [];
      mapdata.features.forEach((item) => {
        dataArr.push({
          name: item.properties.name,
          symbolOffset: [0, "-50%"],
          coord: item.properties.center,
          label: {
            show: true,
            position: "bottom",
          },
        });
      });

      return dataArr;
    },

    

    nowSize(val, initWidth = 1920) {
      return val * (document.documentElement.clientWidth / initWidth);
    },
  },
};
</script>
<style lang="scss" scoped>
.mapbox {
  width: 100%;
  height: 100%;
  position: relative;

  .tab {
    position: absolute;
    top: 10px;
    right: 20px;
    display: flex;
    text-align: center;
  }
}
</style>